<div class="jumbotron animated fadeIn fast">
  <div class="container-fluid">
    <div class="container">
      <div class="row row-margin text-center">
        <h3 class="title">Creación de usuario</h3>
        <div class="space-bar center-block"></div>
      </div>
      <div class="row row-margin text-center">
        <img
          src="assets/images/pages/create-success.png"
          alt="Creación exitosa"
        />
      </div>
      <div class="row row-margin text-center">
        <p>
          Estimado, se ha <b class="primary">creado con éxito el usuario</b>.
          Se enviará un mail al <b>{{ _user.user.email }}</b> con los pasos requeridos para crear su clave.
        </p>
      </div>
      <div class="row text-center">
        <div class="col-md-6 col-table left">
          <div class="row text-left first">
            <div class="col-md-6">
              <span><b>Nombre</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.firstName }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Apellidos</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.lastName }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Tipo de documento</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.docType }}</span>
            </div>
          </div>
          <div class="row text-left last">
            <div class="col-md-6">
              <span><b>Número de documento</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.docNumber }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-table">
          <div class="row text-left first">
            <div class="col-md-6">
              <span><b>Correo</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.email }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Número de teléfono</b></span>
            </div>
            <div class="col-md-6">
              <span>+519{{ _user.user.phone }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Cargo de la empresa</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _user.user.charge }}</span>
            </div>
          </div>
          <div class="row text-left last">
            <div class="col-md-6">
              <span><b>Perfil</b></span>
            </div>
            <div class="col-md-6">
              <span 
              *ngFor="let role of _user.user.roles; let last = last;">
              {{ role.fullName }}<span *ngIf="!last">,&nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-margin">
        <button
          class="button-continue center-block"
          [routerLink]="['/pages/admin/user-management']"
        >
          Ir a gestión de usuario
        </button>
      </div>
    </div>
  </div>
</div>
